import type PickerPluginViewState from 'owa-editor-picker-plugin/lib/schema/PickerPluginViewState';

const CALLOUT_WINDOW_PADDING = 20;

export default function getPluginCalloutMaxHeight(
    viewState: PickerPluginViewState
): number | undefined {
    if (!viewState.targetPoint?.y) {
        return undefined;
    }

    return (
        Math.max(window.innerHeight - viewState.targetPoint.y, viewState.targetPoint.y) -
        CALLOUT_WINDOW_PADDING
    );
}
